Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedSensor = useAnimatedSensor;
var _react = require("react");
var _core = require("../core");
var _commonTypes = require("../commonTypes");
var _threads = require("../threads");
var _worklet_3591825116582_init_data = {
    code: "function eulerToQuaternion(pitch,roll,yaw){const c1=Math.cos(pitch/2);const s1=Math.sin(pitch/2);const c2=Math.cos(roll/2);const s2=Math.sin(roll/2);const c3=Math.cos(yaw/2);const s3=Math.sin(yaw/2);return[s1*c2*c3-c1*s2*s3,c1*s2*c3+s1*c2*s3,c1*c2*s3+s1*s2*c3,c1*c2*c3-s1*s2*s3];}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts",
    sourceMap: '{"version":3,"names":["eulerToQuaternion","pitch","roll","yaw","c1","Math","cos","s1","sin","c2","s2","c3","s3"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts"],"mappings":"AAWA,SAAAA,kBAAAC,KAAA,CAAAC,IAAA,CAAAC,GAAA,QAAAC,EAAA,CAAAC,IAAA,CAAAC,GAAA,CAAAL,KAAA,IACA,MAAAM,EAAA,CAAAF,IAAA,CAAAG,GAAA,CAAAP,KAAA,IACA,MAAAQ,EAAS,CAAAJ,IAAA,CAAAC,GAAA,CAAAJ,IAAiB,CAAC,GAEzB,KAAM,CAAAQ,EAAE,CAAGL,IAAI,CAACG,GAAG,CAACN,IAAA,CAAK,CAAG,CAAC,CAC7B,KAAM,CAAAS,EAAE,CAAGN,IAAI,CAACC,GAAG,CAACH,GAAA,CAAK,EAAG,CAC5B,KAAM,CAAAS,EAAE,CAAGP,IAAI,CAACG,GAAG,CAACL,GAAA,CAAI,CAAG,CAAC,CAC5B,MAAM,CAAEI,EAAA,CAAGE,EAAI,CAACE,EAAI,CAAAP,EAAI,CAAIM,EAAC,CAAAE,EAAA,CAAAR,EAAA,CAAAM,EAAA,CAAAC,EAAA,CAAAJ,EAAA,CAAAE,EAAA,CAAAG,EAAA,CAAAR,EAAA,CAAAK,EAAA,CAAAG,EAAA,CAAAL,EAAA,CAAAG,EAAA,CAAAC,EAAA,CAAAP,EAAA,CAAAK,EAAA,CAAAE,EAAA,CAAAJ,EAAA,CAAAG,EAAA,CAAAE,EAAA,E"}',
    version: "3.5.4"
};
var eulerToQuaternion = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var eulerToQuaternion = function eulerToQuaternion(pitch, roll, yaw) {
        var c1 = Math.cos(pitch / 2);
        var s1 = Math.sin(pitch / 2);
        var c2 = Math.cos(roll / 2);
        var s2 = Math.sin(roll / 2);
        var c3 = Math.cos(yaw / 2);
        var s3 = Math.sin(yaw / 2);
        return [
            s1 * c2 * c3 - c1 * s2 * s3,
            c1 * s2 * c3 + s1 * c2 * s3,
            c1 * c2 * s3 + s1 * s2 * c3,
            c1 * c2 * c3 - s1 * s2 * s3
        ];
    };
    eulerToQuaternion.__closure = {};
    eulerToQuaternion.__initData = _worklet_3591825116582_init_data;
    eulerToQuaternion.__workletHash = 3591825116582;
    eulerToQuaternion.__stackDetails = _e;
    return eulerToQuaternion;
}();
var _worklet_6333234931453_init_data = {
    code: "function adjustRotationToInterfaceOrientation(data){const{eulerToQuaternion}=this.__closure;const{interfaceOrientation:interfaceOrientation,pitch:pitch,roll:roll,yaw:yaw}=data;if(interfaceOrientation===90){data.pitch=roll;data.roll=-pitch;data.yaw=yaw-Math.PI/2;}else if(interfaceOrientation===270){data.pitch=-roll;data.roll=pitch;data.yaw=yaw+Math.PI/2;}else if(interfaceOrientation===180){data.pitch*=-1;data.roll*=-1;data.yaw*=-1;}const q=eulerToQuaternion(data.pitch,data.roll,data.yaw);data.qx=q[0];data.qy=q[1];data.qz=q[2];data.qw=q[3];return data;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts",
    sourceMap: '{"version":3,"names":["adjustRotationToInterfaceOrientation","data","eulerToQuaternion","__closure","interfaceOrientation","pitch","roll","yaw","Math","PI","q","qx","qy","qz","qw"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts"],"mappings":"AA8BA,SAAAA,oCAASA,CAAqCC,IAAA,CAAmB,OAAAC,iBAAA,OAAAC,SAAA,CAE/D,KAAM,CAAEC,oBAAoB,CAApBA,oBAAoB,CAAEC,KAAK,CAALA,KAAK,CAAEC,IAAI,CAAJA,IAAI,CAAEC,GAAA,CAAAA,GAAI,CAAC,CAAGN,IAAI,CACvD,GAAIG,oBAAoB,GAAK,EAAE,CAAE,CAC/BH,IAAI,CAACI,KAAK,CAAGC,IAAI,CACjBL,IAAI,CAACK,IAAI,CAAG,CAACD,KAAK,CAClBJ,IAAI,CAACM,GAAG,CAAGA,GAAG,CAAGC,IAAI,CAACC,EAAE,CAAG,CAAC,CAC9B,CAAC,IAAM,IAAIL,oBAAoB,GAAK,GAAG,CAAE,CACvCH,IAAI,CAACI,KAAK,CAAG,CAACC,IAAI,CAClBL,IAAI,CAACK,IAAI,CAAGD,KAAK,CACjBJ,IAAI,CAACM,GAAG,CAAGA,GAAG,CAAGC,IAAI,CAACC,EAAE,CAAG,CAAC,CAC9B,CAAC,IAAM,IAAIL,oBAAoB,GAAK,GAAG,CAAE,CACvCH,IAAI,CAACI,KAAK,EAAI,CAAC,CAAC,CAChBJ,IAAI,CAACK,IAAI,EAAI,CAAC,CAAC,CACfL,IAAI,CAACM,GAAG,EAAI,CAAC,CAAC,CAChB,CAEA,KAAM,CAAAG,CAAC,CAAGR,iBAAiB,CAACD,IAAI,CAACI,KAAK,CAAEJ,IAAI,CAACK,IAAI,CAAEL,IAAI,CAACM,GAAG,CAAC,CAC5DN,IAAI,CAACU,EAAE,CAAGD,CAAC,CAAC,CAAC,CAAC,CACdT,IAAI,CAACW,EAAE,CAAGF,CAAC,CAAC,CAAC,CAAC,CACdT,IAAI,CAACY,EAAE,CAAGH,CAAC,CAAC,CAAC,CAAC,CACdT,IAAI,CAACa,EAAE,CAAGJ,CAAC,CAAC,CAAC,CAAC,CACd,MAAO,CAAAT,IAAI,CACb"}',
    version: "3.5.4"
};
var adjustRotationToInterfaceOrientation = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var adjustRotationToInterfaceOrientation = function adjustRotationToInterfaceOrientation(data) {
        var interfaceOrientation = data.interfaceOrientation, pitch = data.pitch, roll = data.roll, yaw = data.yaw;
        if (interfaceOrientation === 90) {
            data.pitch = roll;
            data.roll = -pitch;
            data.yaw = yaw - Math.PI / 2;
        } else if (interfaceOrientation === 270) {
            data.pitch = -roll;
            data.roll = pitch;
            data.yaw = yaw + Math.PI / 2;
        } else if (interfaceOrientation === 180) {
            data.pitch *= -1;
            data.roll *= -1;
            data.yaw *= -1;
        }
        var q = eulerToQuaternion(data.pitch, data.roll, data.yaw);
        data.qx = q[0];
        data.qy = q[1];
        data.qz = q[2];
        data.qw = q[3];
        return data;
    };
    adjustRotationToInterfaceOrientation.__closure = {
        eulerToQuaternion: eulerToQuaternion
    };
    adjustRotationToInterfaceOrientation.__initData = _worklet_6333234931453_init_data;
    adjustRotationToInterfaceOrientation.__workletHash = 6333234931453;
    adjustRotationToInterfaceOrientation.__stackDetails = _e;
    return adjustRotationToInterfaceOrientation;
}();
var _worklet_14148869364242_init_data = {
    code: "function adjustVectorToInterfaceOrientation(data){const{interfaceOrientation:interfaceOrientation,x:x,y:y}=data;if(interfaceOrientation===90){data.x=-y;data.y=x;}else if(interfaceOrientation===270){data.x=y;data.y=-x;}else if(interfaceOrientation===180){data.x*=-1;data.y*=-1;}return data;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts",
    sourceMap: '{"version":3,"names":["adjustVectorToInterfaceOrientation","data","interfaceOrientation","x","y"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts"],"mappings":"AAuDA,SAAAA,kCAASA,CAAmCC,IAAA,CAAa,CAEvD,KAAM,CAAEC,oBAAoB,CAApBA,oBAAoB,CAAEC,CAAC,CAADA,CAAC,CAAEC,CAAA,CAAAA,CAAE,CAAC,CAAGH,IAAI,CAC3C,GAAIC,oBAAoB,GAAK,EAAE,CAAE,CAC/BD,IAAI,CAACE,CAAC,CAAG,CAACC,CAAC,CACXH,IAAI,CAACG,CAAC,CAAGD,CAAC,CACZ,CAAC,IAAM,IAAID,oBAAoB,GAAK,GAAG,CAAE,CACvCD,IAAI,CAACE,CAAC,CAAGC,CAAC,CACVH,IAAI,CAACG,CAAC,CAAG,CAACD,CAAC,CACb,CAAC,IAAM,IAAID,oBAAoB,GAAK,GAAG,CAAE,CACvCD,IAAI,CAACE,CAAC,EAAI,CAAC,CAAC,CACZF,IAAI,CAACG,CAAC,EAAI,CAAC,CAAC,CACd,CACA,MAAO,CAAAH,IAAI,CACb"}',
    version: "3.5.4"
};
var adjustVectorToInterfaceOrientation = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var adjustVectorToInterfaceOrientation = function adjustVectorToInterfaceOrientation(data) {
        var interfaceOrientation = data.interfaceOrientation, x = data.x, y = data.y;
        if (interfaceOrientation === 90) {
            data.x = -y;
            data.y = x;
        } else if (interfaceOrientation === 270) {
            data.x = y;
            data.y = -x;
        } else if (interfaceOrientation === 180) {
            data.x *= -1;
            data.y *= -1;
        }
        return data;
    };
    adjustVectorToInterfaceOrientation.__closure = {};
    adjustVectorToInterfaceOrientation.__initData = _worklet_14148869364242_init_data;
    adjustVectorToInterfaceOrientation.__workletHash = 14148869364242;
    adjustVectorToInterfaceOrientation.__stackDetails = _e;
    return adjustVectorToInterfaceOrientation;
}();
var _worklet_4762875893066_init_data = {
    code: "function anonymous(data){const{adjustToInterfaceOrientation,sensorType,SensorType,adjustRotationToInterfaceOrientation,adjustVectorToInterfaceOrientation,sensorData,callMicrotasks}=this.__closure;if(adjustToInterfaceOrientation){if(sensorType===SensorType.ROTATION){data=adjustRotationToInterfaceOrientation(data);}else{data=adjustVectorToInterfaceOrientation(data);}}sensorData.value=data;callMicrotasks();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts",
    sourceMap: '{"version":3,"names":["anonymous","data","adjustToInterfaceOrientation","sensorType","SensorType","adjustRotationToInterfaceOrientation","adjustVectorToInterfaceOrientation","sensorData","callMicrotasks","__closure","ROTATION","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedSensor.ts"],"mappings":"AA6GmD,SAAAA,SAASA,CAAAC,IAAA,QAAAC,4BAAA,CAAAC,UAAA,CAAAC,UAAA,CAAAC,oCAAA,CAAAC,kCAAA,CAAAC,UAAA,CAAAC,cAAA,OAAAC,SAAA,CAEtD,GAAIP,4BAA4B,CAAE,CAChC,GAAIC,UAAU,GAAKC,UAAU,CAACM,QAAQ,CAAE,CACtCT,IAAI,CAAGI,oCAAoC,CAACJ,IAAqB,CAAC,CACpE,CAAC,IAAM,CACLA,IAAI,CAAGK,kCAAkC,CAACL,IAAe,CAAC,CAC5D,CACF,CACAM,UAAU,CAACI,KAAK,CAAGV,IAAI,CACvBO,cAAc,CAAC,CAAC,CAClB"}',
    version: "3.5.4"
};
function useAnimatedSensor(sensorType, userConfig) {
    var config = Object.assign({
        interval: "auto",
        adjustToInterfaceOrientation: true,
        iosReferenceFrame: _commonTypes.IOSReferenceFrame.Auto
    }, userConfig);
    var ref = (0, _react.useRef)({
        sensor: (0, _core.initializeSensor)(sensorType, config),
        unregister: function unregister() {},
        isAvailable: false,
        config: config
    });
    (0, _react.useEffect)(function() {
        var newConfig = Object.assign({}, config, userConfig);
        ref.current.sensor = (0, _core.initializeSensor)(sensorType, newConfig);
        var sensorData = ref.current.sensor;
        var adjustToInterfaceOrientation = ref.current.config.adjustToInterfaceOrientation;
        var id = (0, _core.registerSensor)(sensorType, config, function() {
            var _e = [
                new global.Error(),
                -8,
                -27
            ];
            var anonymous = function anonymous(data) {
                if (adjustToInterfaceOrientation) {
                    if (sensorType === _commonTypes.SensorType.ROTATION) {
                        data = adjustRotationToInterfaceOrientation(data);
                    } else {
                        data = adjustVectorToInterfaceOrientation(data);
                    }
                }
                sensorData.value = data;
                (0, _threads.callMicrotasks)();
            };
            anonymous.__closure = {
                adjustToInterfaceOrientation: adjustToInterfaceOrientation,
                sensorType: sensorType,
                SensorType: _commonTypes.SensorType,
                adjustRotationToInterfaceOrientation: adjustRotationToInterfaceOrientation,
                adjustVectorToInterfaceOrientation: adjustVectorToInterfaceOrientation,
                sensorData: sensorData,
                callMicrotasks: _threads.callMicrotasks
            };
            anonymous.__initData = _worklet_4762875893066_init_data;
            anonymous.__workletHash = 4762875893066;
            anonymous.__stackDetails = _e;
            return anonymous;
        }());
        if (id !== -1) {
            ref.current.unregister = function() {
                return (0, _core.unregisterSensor)(id);
            };
            ref.current.isAvailable = true;
        } else {
            ref.current.unregister = function() {};
            ref.current.isAvailable = false;
        }
        return function() {
            ref.current.unregister();
        };
    }, [
        sensorType,
        userConfig
    ]);
    return ref.current;
}
